import { render, staticRenderFns } from "../../templates/form/animal-form.pug?vue&type=template&id=c3477eea&lang=pug&"
import script from "./AnimalForm.vue?vue&type=script&lang=js&"
export * from "./AnimalForm.vue?vue&type=script&lang=js&"
import style0 from "./AnimalForm.vue?vue&type=style&index=0&id=c3477eea&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports